import React, { useEffect, useState } from 'react'

export default function OrderStatusSelectionOption({ label, value, selected, onChange }) {
  const [className, setClassName] = useState('')
  function OrderStatus(label, className) {
    return <div className={className}>{label}</div>
  }
  function OrderStatusActived(label, value, className, onChange) {
    return (
      <button type="button" className={className} onClick={() => onChange(value)}>
        {label}
      </button>
    )
  }
  useEffect(() => {
    let cls = 'd-flex align-items-center justify-content-center '
    switch (value) {
      case 'PENDING':
        cls += selected ? 'btn btn-info' : 'btn btn-outline-info'
        break
      case 'CONFIRMED':
        cls += selected ? 'btn btn-warning' : 'btn btn-outline-warning'
        break
      case 'BLOCK':
        cls += selected ? 'btn btn-dark' : 'btn btn-outline-dark'
        break
      case 'SUCCESS':
        cls += selected ? 'btn btn-success' : 'btn btn-outline-success'
        break
      case 'CANCEL':
        cls += selected ? 'btn btn-danger' : 'btn btn-outline-danger'
        break
      default:
        cls += selected ? 'btn btn-dark' : 'btn btn-outline-dark'
        break
    }
    setClassName(cls)
    return () => {}
  }, [value, selected])
  return <>{selected ? OrderStatus(label, className) : OrderStatusActived(label, value, className, onChange)}</>
}
